import React, { useState } from 'react';
import { tokens } from '../design-system';

/**
 * System-wide banner for outages, maintenance, etc.
 *
 * To show a banner: set enabled to true and update the message.
 * To take it down: set enabled to false.
 */
const BANNER_CONFIG = {
  enabled: false,
  message: 'Plan generation is currently unavailable due to a vendor outage. We are monitoring the situation.',
  type: 'warning', // 'warning' | 'error' | 'info'
  dismissible: true,
};

const TYPE_STYLES = {
  warning: {
    bg: tokens.colors.warning?.[500] || '#F7CA84',
    text: '#1a1a1a',
    border: tokens.colors.warning?.[600] || '#e5b56a',
  },
  error: {
    bg: tokens.colors.error?.[500] || '#D24E26',
    text: '#ffffff',
    border: tokens.colors.error?.[600] || '#b8421f',
  },
  info: {
    bg: tokens.colors.info?.[500] || '#5B8FD9',
    text: '#ffffff',
    border: tokens.colors.info?.[600] || '#4a7bc4',
  },
};

export default function SystemBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (!BANNER_CONFIG.enabled || dismissed) {
    return null;
  }

  const style = TYPE_STYLES[BANNER_CONFIG.type] || TYPE_STYLES.warning;

  return (
    <div style={{
      backgroundColor: style.bg,
      borderBottom: `1px solid ${style.border}`,
      padding: `${tokens.spacing[2]} ${tokens.spacing[4]}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: tokens.spacing[3],
      fontSize: tokens.typography.fontSize.sm,
      fontWeight: tokens.typography.fontWeight.medium,
      color: style.text,
    }}>
      <span>{BANNER_CONFIG.message}</span>
      {BANNER_CONFIG.dismissible && (
        <button
          onClick={() => setDismissed(true)}
          style={{
            background: 'none',
            border: 'none',
            color: style.text,
            cursor: 'pointer',
            padding: '2px 6px',
            fontSize: '16px',
            lineHeight: 1,
            opacity: 0.7,
          }}
          aria-label="Dismiss banner"
        >
          &times;
        </button>
      )}
    </div>
  );
}
